import React from "react";
import { useLocation } from 'react-router-dom';
import Header from '../Header';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Typography,
} from "@mui/material";
import OTPInput from "../OTP";

const PaymentConfirm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { selectedBiller, number, amount } = location.state || ''; // Extract parameters from the URL
    
  // Handle form submission
  const handlePay = () => {
    if (selectedBiller && number && amount) {
      // Redirect to a different page with query parameters
      //navigate(`/payment-success?biller=${selectedBiller}&number=${number}&amount=${amount}`);
      navigate("/payment-success", {
        state: { selectedBiller, number, amount },
      });
    } else {
      alert('Please fill all fields before proceeding.');
    }
  };
    return (
    <div className="bg-container">
        <Header />
        <Box
          sx={{
            maxWidth: 500,
            minWidth: 500,
            minHeight: 400,
            margin: "150",
            padding: 4,
            boxShadow: 3,
            borderRadius: 2,
            backgroundColor: "#f9f9f9",
            position: "relative", // Make the Box a positioned container
          }}
        >
          <Typography variant="h4" gutterBottom align="center">
            Bill Details
          </Typography>
          
          {/* Display Selected Biller */}
          <Typography variant="body1" sx={{ marginBottom: 2, whiteSpace: "pre-line" }}>
              <strong>Biller:</strong> {"SS Gas Limited\nConsumer id: 54210\n\nMrs Preeti Gupta\n\n2832 Prestige Kew Gardens\n Near Rohan Jharoka\nKarnataka Bangalore - 560037"}
          </Typography>

          {/* Display Entered Number */}
          <Typography variant="body1" sx={{ marginBottom: 2 }}>
              <strong>Amount:</strong> ₹{840.95}
          </Typography>

          <Typography variant="body1" sx={{ marginBottom: 2 }}>
              <strong>OTP:</strong> <OTPInput></OTPInput>
          </Typography>
          
      

      {/* Pay Button */}
      <Button
        variant="contained"
        color="primary"
        onClick={handlePay}
        sx={{
            position: "absolute", // Position the button absolutely
            bottom: 16, // Add spacing from the bottom
            left: 16, // Add spacing from the left
            right: 16, // Add spacing from the right
          }}
      >
        PAY
      </Button>
    </Box>
    </div>
    );
};

export default PaymentConfirm;